import { render, staticRenderFns } from "./DataPointList.vue?vue&type=template&id=18ab8e5a"
import script from "./DataPointList.vue?vue&type=script&lang=js"
export * from "./DataPointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports